import type { MediaItem } from "./types";

export async function fetchMediaForDownload(item: MediaItem, options: { validateURL?: (url: string) => boolean; redirect?: RequestRedirect } = {}): Promise<Blob> {
  let response: Response;
  try {
    response = await fetch(item.url, {
      mode: "cors",
      credentials: "omit",
      referrerPolicy: "no-referrer",
      redirect: options.redirect || "follow"
    });
  } catch {
    throw new Error("DIRECT_DOWNLOAD_BLOCKED");
  }
  if (!response.ok || response.type === "opaque" || (options.validateURL && !options.validateURL(response.url || item.url))) {
    throw new Error("DIRECT_DOWNLOAD_BLOCKED");
  }
  return response.blob();
}
